import { z } from "zod";
import { ProjectSchema } from "./Project";

export const UpdateProjectRequestSchema = ProjectSchema.pick({
    accountId: true,
    name: true,
    lat: true,
    lng: true,
    description: true,
    ownerId: true,
    startDate: true,
    endDate: true
})

export type UpdateProjectRequest = z.infer<typeof UpdateProjectRequestSchema>;